<template>
  <form>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ this.selectedTask.onboarding_task.name }}</p>
      </header>
      <section class="modal-card-body">
        <p class="has-text-primary has-text-weight-bold pb-sm has-border-b has-border-lg">Task Info</p>
        <table class="table is-fullwidth is-striped is-size-7 is-narrow">
          <tr v-for="row in formattedData" :key="row.id">
            <th>{{ row?.label }}</th>
            <td class="has-text-right">{{ row?.value }}</td>
          </tr>
        </table>
      </section>
      <footer class="modal-card-foot is-justify-content-right">
        <b-button @click="$parent.close()">Close</b-button>
      </footer>
    </div>
  </form>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  components: {

  },
  data () {
    return {

    }
  },
  computed: {
    ...mapGetters(['context']),
    formattedData () {
      return Object.entries(this.selectedTask?.info).map(([id, val]) => {
        if (typeof val === 'object' && val !== null && 'label' in val && 'value' in val) {
          // Case 1: already has label & value
          return { id, label: val.label, value: val.value }
        } else {
          // Case 2: primitive (boolean, string, number, etc.)
          return { id, label: this.formatLabel(id), value: val }
        }
      })
    }
  },
  methods: {
    // helper: convert camelCase / snake_case IDs into readable labels
    formatLabel (id) {
      return id
        .replace(/([A-Z])/g, ' $1') // split camelCase words
        .replace(/_/g, ' ') // replace underscores
        .replace(/\s+/g, ' ') // clean multiple spaces
        .replace(/^./, str => str.toUpperCase()) // capitalize first letter
    }
  },
  mounted () {
  },
  props: {
    selectedTask: {
      type: Object,
      required: true
    }
  }
}
</script>
